import { createAsyncThunk } from '@reduxjs/toolkit';

import { deviceAvailability } from '../../../service/graphql/machine/deviceAvailability';

import { AsyncThunkConfig } from '../../store';

import { IDeviceAvailability } from '../types';

export const checkVinDeviceAvailabilityThunk = createAsyncThunk<
  IDeviceAvailability | undefined,
  string,
  AsyncThunkConfig
>('addMachine/checkVinDeviceAvailability', async (vin, { getState }) => {
  const {
    launchDarkly,
    selectedAccount: { activeAccountId },
  } = getState();
  if (!activeAccountId) {
    throw new Error('No account selected!');
  }
  return deviceAvailability(launchDarkly.data, vin, activeAccountId);
});
